import React from 'react';
import { useTranslation } from 'react-utilities';
import { NAPageItemConfigType, PageItemRenderingProps } from '../ConfigTypes';
import getFormattedFullDate from '../../utils/getFormattedFullDate';

/**
 * The time at which the consequence is issued
 */
const StartDatePageItem = (props: PageItemRenderingProps): JSX.Element => {
  const { translate } = useTranslation();
  const { punishmentData } = props;
  const startDateTimeFormattedString: string =
    punishmentData.beginDate != null ? getFormattedFullDate(punishmentData.beginDate) : '';

  return (
    <div data-testid='start-date'>
      {/* eslint-disable-next-line react/jsx-no-literals */}
      {translate('Messages.ReviewedTitle')}: <b>{startDateTimeFormattedString}</b>
    </div>
  );
};

const StartDatePageItemConfig: NAPageItemConfigType = {
  getIsVisible: () => {
    return true;
  },
  renderComponent: StartDatePageItem,
  configName: 'start-date'
};

export default StartDatePageItemConfig;
